import { i18n } from "@/plugins/vuetify";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { clientPageTitle } from "@/utils/ClientAdministrationDetail";
import { getValue, setValue } from "@/utils/SecureLocalStorage";

/** Per client, the title its detail showed last ("SanTec (1234)"), for the sub-pages' app bar. */
function clientTitleKey(clientId: string): string {
  return `ADMIN_CLIENT_TITLE_${clientId}`;
}

/** Kept by the client detail once loaded, so the client's sub-pages can name it in the app bar. */
export function rememberClientTitle(clientId: string, title: string): void {
  setValue(clientTitleKey(clientId), title);
}

/**
 * Sets the app bar of a page inside a client to "Mandanten > <client> > <pages>", the client's name
 * as its detail last showed it (session storage; left out when unknown).
 */
export function setClientPageToolbarTitle(clientId: string, ...pages: string[]): void {
  const base = i18n.t("admin.clients.title").toString();
  ToolbarContentModule.setToolbarTitle(clientPageTitle(base, getValue(clientTitleKey(clientId)) ?? null, ...pages));
}
